<template>
    <v-row no-gutters>
        <v-col cols="12">
            <div class="pa-0 pa-sm-2">
                <v-card class="pa-2 pa-sm-4" variant="outlined">
                    <div class="d-flex align-center" style="position: absolute; top: 12px; right: 24px; z-index: 1">
                        <v-icon start size="small"> mdi-account-check-outline </v-icon>
                        <span class="text-caption">
                            {{ `${orderTravelers.length} ${$t('guest', orderTravelers.length)}` }}
                        </span>
                        <order-travelers-dialog
                            v-if="hasQuoteServices"
                            :order-travelers="orderTravelers"
                            :order="order"
                        />
                    </div>
                    <template v-if="orderTravelersWithNames.length">
                        <v-slide-y-transition class="v-row" group tag="div">
                            <v-col
                                v-for="(traveler, index) in orderTravelersWithNamesSliced"
                                :key="traveler.travelerId"
                                cols="12"
                                md="6"
                            >
                                <v-card elevation="0" class="full-height">
                                    <v-card-text class="full-height py-1">
                                        <v-row>
                                            <v-col cols="4" md="3" xl="2" class="text-capitalize">
                                                {{
                                                    index === 0 ? $t('lead_guest') : $t('guest', 1) + ' ' + (index + 1)
                                                }}
                                            </v-col>
                                            <v-col cols="8" md="9" xl="10">
                                                <div>
                                                    {{ traveler.prefix || '' }}
                                                </div>
                                                <div class="text-subtitle-2 text-sm-h6 font-weight-bold text-black">
                                                    {{
                                                        `${traveler.name[0].firstName || ''} ${
                                                            traveler.name[0].lastName || ''
                                                        }`
                                                    }}
                                                </div>
                                                <div class="d-flex align-md-center flex-column flex-md-row">
                                                    <div v-if="traveler.email">
                                                        {{ `${traveler.email}${traveler.phone ? ',' : ''}` }}
                                                        &nbsp;
                                                    </div>
                                                    <div v-if="traveler.phone">
                                                        {{ ` ${traveler.phone}` }}
                                                    </div>
                                                </div>
                                                <div v-if="traveler.passports && traveler.passports.length">
                                                    {{ $t('documents') }}:
                                                    {{
                                                        `${traveler.passports[0].number || ''}${
                                                            traveler.passports[0].expiryDate
                                                                ? ` (${traveler.passports[0].expiryDate})`
                                                                : ''
                                                        }`
                                                    }}
                                                </div>
                                                <div v-if="traveler.dateOfBirth">
                                                    {{ $t('birthdate') }}:
                                                    {{ `${birthDateFormatted(traveler)}` }}
                                                    <span v-if="orderEndDate && showAge">
                                                        {{
                                                            `(${getAge(traveler.dateOfBirth)} ${showYrs ? 'yrs' : ''})`
                                                        }}
                                                    </span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-divider v-if="orderTravelersWithNamesSliced.length > 2" />
                                </v-card>
                            </v-col>
                        </v-slide-y-transition>
                        <v-row v-if="orderTravelersWithNames.length > expandLimit">
                            <v-col>
                                <v-btn
                                    color="primary"
                                    size="small"
                                    variant="text"
                                    style="text-transform: none"
                                    @click="expanded = !expanded"
                                >
                                    <span class="text-caption">
                                        {{ expanded ? $t('collapse') : $t('view_all') }}
                                    </span>
                                    <v-icon end size="small">
                                        {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <div v-else class="text-center text-caption text--secondary full-width pb-4">
                        {{ $t('no_data') }}
                    </div>
                </v-card>
            </div>
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import OrderTravelersDialog from '@/components/account/OrderTravelersDialog.vue'

    @Component({
        components: {OrderTravelersDialog},
    })
    export class OrderDetailsTravelerList extends Vue {
        @Prop({required: true, type: Object}) order
        @Prop({required: true, type: Array}) orderTravelers
        @Prop() orderEndDate

        expanded = false
        expandLimit = 4

        created() {
            if (this.isMobile) this.expandLimit = 0
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }

        getAge(dateOfBirth) {
            return this.$dateFns.differenceInYears(new Date(this.orderEndDate), this.$dateFns.parseISO(dateOfBirth))
        }

        birthDateFormatted(traveler) {
            return traveler.dateOfBirth
        }

        get showAge() {
            return false
        }

        get orderTravelersWithNames() {
            return this.orderTravelers.filter(t => t.name[0].firstName || t.name[0].lastName)
        }

        get orderTravelersWithNamesSliced() {
            return this.expanded
                ? this.orderTravelersWithNames
                : this.orderTravelersWithNames.slice(0, this.expandLimit)
        }

        get showYrs() {
            return false
        }

        get hasQuoteServices() {
            return this.order.services.findIndex(({status}) => status === 'Quote') !== -1
        }
    }

    export default OrderDetailsTravelerList
</script>
